// Zentrale SEO-Konstanten – hier Domain nach Strato-Verifizierung ändern
export const SITE_URL = "https://tm-krefeld.de";
export const SITE_NAME = "Thermomix® Krefeld – Jennifer Laak";
export const OWNER_NAME = "Jennifer Laak";
export const OWNER_PHONE = "+491721697433";
export const OWNER_EMAIL = "jennifer-laak@gmx.de";
export const OWNER_ADDRESS = {
  street: "Franz-Hartz-Straße 17",
  postalCode: "47839",
  city: "Krefeld",
  country: "DE"
};
export const HERO_IMAGE = "https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/hht6wwln_a6d10632-77a1-4936-a4cb-89e01d811e67.jpeg";
// Für Standort-Seiten: neutrales Thermomix-Küchen-Bild (kein Portrait, damit auf allen Breakpoints sauber)
export const LOCATION_HERO_IMAGE = "https://customer-assets.emergentagent.com/job_thermomix-zuhause/artifacts/6145ht4f_1bfbb0f1-ab00-45be-9053-392db48d3757.jpeg";
